import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=e3f3ed0c&scoped=true&"
import script from "./ProfileSettings.vue?vue&type=script&lang=ts&"
export * from "./ProfileSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=e3f3ed0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f3ed0c",
  null
  
)

export default component.exports